angular.module('festzelt-os.modules.action_log', [
    'festzelt-os.components'
]);

require('./components/entity-change-log/component');

require('./controller/extended-listview');

require('./factories/action-log-entry-factory');
require('./routes');
require('./store/action-log-entries');



// WEBPACK FOOTER //
// ./src/app/modules/action_log/module.js